module.exports = __webpack_public_path__ + "static/media/Sciences.5e66e136.gif";